import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * UI pura — lógica de carregar/validar/salvar o parecer fica no componente pai.
 */
@Component({
  selector: 'app-parecer-modal',
  templateUrl: './parecer-modal.component.html'
})
export class ParecerModalComponent {
  @Input() aberto = false;
  @Input() titulo = '';
  @Input() nomeAluno = '';
  @Input() carregando = false;
  @Input() salvando = false;
  @Input() texto = '';

  @Output() textoChange = new EventEmitter<string>();
  @Output() salvar = new EventEmitter<void>();
  @Output() fechar = new EventEmitter<void>();

  onTextoChange(valor: string): void {
    this.texto = valor;
    this.textoChange.emit(valor);
  }
}
